export const normalizePhoneNumber = (value: string) => (value || '').replace(/\(|\)|\-|\s/g, '');
